/**
 * Store ids that are needed without importing the store module itself.
 *
 * The permission store imports the route tree, so the routes must not import it (import cycle).
 * They read its state from the active Pinia instance by this id instead (see
 * `currentSettingsFallback` in src/views/settings/lib/redirects.ts). Keep this module free of
 * imports.
 */
export const PERMISSION_STORE_ID = "permission";
